/**
 * space接口配置
 */
import type { ApiEndpoint } from '../types';
import { API_CATEGORIES } from '../constants';

export const spaceEndpoints: ApiEndpoint[] = [
  {
    id: 'space-list',
    method: 'GET',
    path: '/api/spaces',
    name: '获取空间列表',
    description: '分页查询空间列表，支持多条件搜索',
    category: API_CATEGORIES.SPACE,
    queryParams: [
      { name: 'page', type: 'number', required: false, description: '页码', example: '1' },
      { name: 'limit', type: 'number', required: false, description: '每页条数', example: '10' },
      { name: 'type', type: 'string', required: false, description: '空间类型', example: 'BUILDING' },
      { name: 'status', type: 'string', required: false, description: '空间状态', example: 'ACTIVE' },
      { name: 'parentId', type: 'string', required: false, description: '父空间ID' },
      { name: 'search', type: 'string', required: false, description: '搜索关键词' },
      { name: 'tags', type: 'string|array', required: false, description: '标签ID或标签ID数组' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '空间列表' },
      { name: 'pagination.total', type: 'number', description: '总记录数' },
      { name: 'pagination.page', type: 'number', description: '当前页码' },
      { name: 'pagination.limit', type: 'number', description: '每页条数' }
    ],
    requiredPermission: 'msspace:space:view',
    responseExample: JSON.stringify({
      success: true,
      data: [
        {
          id: "55a8b310-f590-4671-8a78-db5a9de76e3c",
          name: "北京三元桥燕莎店",
          type: "BUILDING",
          spacePath: "北京三元桥燕莎店",
          parentId: null,
          description: "",
          status: "ACTIVE",
          createdAt: "2025-10-07T11:46:16.822Z",
          updatedAt: "2025-11-19T06:32:03.007Z",
          tags: []
        }
      ],
      pagination: {
        total: 10,
        page: 1,
        limit: 10
      },
      message: "查询成功"
    }, null, 2)
  },
  {
    id: 'space-create',
    method: 'POST',
    path: '/api/spaces',
    name: '创建空间',
    description: '创建新的空间',
    category: API_CATEGORIES.SPACE,
    bodyParams: [
      { name: 'name', type: 'string', required: true, description: '空间名称' },
      { name: 'type', type: 'string', required: true, description: '空间类型', example: 'BUILDING|AREA|SPACE' },
      { name: 'parentId', type: 'string', required: false, description: '父空间ID（UUID）' },
      { name: 'description', type: 'string', required: false, description: '空间描述' },
      { name: 'status', type: 'string', required: false, description: '空间状态', example: 'ACTIVE|INACTIVE|MAINTENANCE' },
      { name: 'tagIds', type: 'array', required: false, description: '标签ID数组' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '创建的空间信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:space:create',
    responseExample: JSON.stringify({
      success: true,
      data: {
        id: "55a8b310-f590-4671-8a78-db5a9de76e3c",
        name: "新空间",
        type: "SPACE",
        spacePath: "北京三元桥燕莎店:新空间",
        parentId: "bb108f1f-c08e-4a4c-b011-32c7a844dc9d",
        description: "",
        status: "ACTIVE",
        createdAt: "2025-10-07T11:46:16.822Z",
        updatedAt: "2025-10-07T11:46:16.822Z",
        tags: []
      },
      message: "空间创建成功"
    }, null, 2)
  },
  {
    id: 'space-batch-delete',
    method: 'POST',
    path: '/api/spaces/batch-delete',
    name: '批量删除空间',
    description: '批量删除空间',
    category: API_CATEGORIES.SPACE,
    bodyParams: [
      { name: 'ids', type: 'array', required: true, description: '空间ID数组' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:space:delete'
  },
  {
    id: 'space-detail',
    method: 'GET',
    path: '/api/spaces/:id',
    name: '获取空间详情',
    description: '根据ID获取空间详细信息',
    category: API_CATEGORIES.SPACE,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '空间详细信息' }
    ],
    requiredPermission: 'msspace:space:view',
    responseExample: JSON.stringify({
      success: true,
      data: {
        id: "55a8b310-f590-4671-8a78-db5a9de76e3c",
        name: "北京三元桥燕莎店",
        type: "BUILDING",
        spacePath: "北京三元桥燕莎店",
        parentId: null,
        description: "",
        status: "ACTIVE",
        createdAt: "2025-10-07T11:46:16.822Z",
        updatedAt: "2025-11-19T06:32:03.007Z",
        tags: [
          {
            id: "fc6a3439-1668-44bb-b5db-4d595216c984",
            name: "建筑",
            icon: "<svg>...</svg>",
            createdAt: "2025-10-07T11:34:41.701Z",
            updatedAt: "2025-10-07T11:34:41.701Z"
          }
        ]
      },
      message: "查询成功"
    }, null, 2)
  },
  {
    id: 'space-update',
    method: 'PUT',
    path: '/api/spaces/:id',
    name: '更新空间',
    description: '更新空间信息',
    category: API_CATEGORIES.SPACE,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    bodyParams: [
      { name: 'name', type: 'string', required: false, description: '空间名称' },
      { name: 'type', type: 'string', required: false, description: '空间类型' },
      { name: 'parentId', type: 'string', required: false, description: '父空间ID' },
      { name: 'description', type: 'string', required: false, description: '空间描述' },
      { name: 'status', type: 'string', required: false, description: '空间状态' },
      { name: 'tagIds', type: 'array', required: false, description: '标签ID数组' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '更新后的空间信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:space:update'
  },
  {
    id: 'space-delete',
    method: 'DELETE',
    path: '/api/spaces/:id',
    name: '删除空间',
    description: '根据ID删除空间',
    category: API_CATEGORIES.SPACE,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:space:delete'
  },
  {
    id: 'space-tree',
    method: 'GET',
    path: '/api/spaces/tree',
    name: '获取空间树',
    description: '获取空间的树形结构，支持通过 rootId 查询指定节点下的树结构',
    category: API_CATEGORIES.SPACE,
    queryParams: [
      { name: 'rootId', type: 'string', required: false, description: '根节点ID（可选，不传则返回所有根节点）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '空间树结构' }
    ],
    requiredPermission: 'msspace:space:view',
    responseExample: JSON.stringify({
      success: true,
      data: [
        {
          id: "55a8b310-f590-4671-8a78-db5a9de76e3c",
          name: "北京三元桥燕莎店",
          type: "BUILDING",
          spacePath: "北京三元桥燕莎店",
          parentId: null,
          description: "",
          status: "ACTIVE",
          createdAt: "2025-10-07T11:46:16.822Z",
          updatedAt: "2025-11-19T06:32:03.007Z",
          tags: [
            {
              id: "fc6a3439-1668-44bb-b5db-4d595216c984",
              name: "建筑",
              icon: "<svg>...</svg>",
              createdAt: "2025-10-07T11:34:41.701Z",
              updatedAt: "2025-10-07T11:34:41.701Z"
            }
          ],
          children: [],
          _count: {
            children: 0
          }
        }
      ],
      message: "空间树查询成功"
    }, null, 2)
  },
  {
    id: 'space-tags',
    method: 'GET',
    path: '/api/spaces/tags',
    name: '获取空间标签字典',
    description: '获取所有空间使用的标签字典',
    category: API_CATEGORIES.SPACE,
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '标签字典列表' }
    ],
    requiredPermission: 'msspace:space:view'
  },
  {
    id: 'space-statistics',
    method: 'GET',
    path: '/api/spaces/statistics',
    name: '获取空间统计',
    description: '获取空间统计信息',
    category: API_CATEGORIES.SPACE,
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '统计信息' }
    ],
    requiredPermission: 'msspace:space:view'
  },
  {
    id: 'space-details',
    method: 'GET',
    path: '/api/spaces/:id/details',
    name: '获取空间节点详情',
    description: '获取空间节点的详细信息，包括关联数据',
    category: API_CATEGORIES.SPACE,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '空间节点详情' }
    ],
    requiredPermission: 'msspace:space:view'
  },
  {
    id: 'space-subordinates',
    method: 'GET',
    path: '/api/spaces/:id/subordinates',
    name: '获取空间及下属',
    description: '获取空间及其所有递归下属空间（树结构）',
    category: API_CATEGORIES.SPACE,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data.node', type: 'object', description: '当前节点信息' },
      { name: 'data.subordinates', type: 'array', description: '所有下属节点（递归）' }
    ],
    requiredPermission: 'msspace:space:view',
    responseExample: JSON.stringify({
      success: true,
      data: {
        node: {
          id: "55a8b310-f590-4671-8a78-db5a9de76e3c",
          name: "北京三元桥燕莎店",
          type: "BUILDING",
          tags: [],
          _count: {
            children: 2,
            coordinates: 1,
            markers: 10
          }
        },
        subordinates: [
          {
            id: "child-id-1",
            name: "一层",
            type: "AREA",
            subordinates: []
          }
        ]
      },
      message: "节点及下属节点查询成功"
    }, null, 2)
  },
  {
    id: 'space-children',
    method: 'GET',
    path: '/api/spaces/:id/children',
    name: '获取子空间',
    description: '获取指定空间的子空间列表',
    category: API_CATEGORIES.SPACE,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    queryParams: [
      { name: 'page', type: 'number', required: false, description: '页码' },
      { name: 'limit', type: 'number', required: false, description: '每页条数' },
      { name: 'type', type: 'string', required: false, description: '空间类型' },
      { name: 'status', type: 'string', required: false, description: '空间状态' },
      { name: 'search', type: 'string', required: false, description: '搜索关键词' },
      { name: 'tags', type: 'string|array', required: false, description: '标签ID或标签ID数组' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '子空间列表' },
      { name: 'pagination', type: 'object', description: '分页信息' }
    ],
    requiredPermission: 'msspace:space:view'
  },
  {
    id: 'space-building',
    method: 'GET',
    path: '/api/spaces/:id/building',
    name: '获取所属建筑',
    description: '递归向上查找空间所属的建筑节点',
    category: API_CATEGORIES.SPACE,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '建筑信息' }
    ],
    requiredPermission: 'msspace:space:view',
    responseExample: JSON.stringify({
      success: true,
      data: {
        id: "55a8b310-f590-4671-8a78-db5a9de76e3c",
        name: "北京三元桥燕莎店",
        type: "BUILDING"
      },
      message: "所属建筑查询成功"
    }, null, 2)
  },
  {
    id: 'space-area',
    method: 'GET',
    path: '/api/spaces/:id/area',
    name: '获取所属区域',
    description: '递归向上查找空间所属的区域节点',
    category: API_CATEGORIES.SPACE,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '区域信息' }
    ],
    requiredPermission: 'msspace:space:view',
    responseExample: JSON.stringify({
      success: true,
      data: {
        id: "area-id-1",
        name: "一层",
        type: "AREA"
      },
      message: "所属区域查询成功"
    }, null, 2)
  },
  {
    id: 'space-hierarchy',
    method: 'GET',
    path: '/api/spaces/:id/hierarchy',
    name: '获取空间层级',
    description: '获取空间的完整层级路径（从根节点到当前节点）',
    category: API_CATEGORIES.SPACE,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '层级关系数组（从根到当前节点）' }
    ],
    requiredPermission: 'msspace:space:view',
    responseExample: JSON.stringify({
      success: true,
      data: [
        {
          id: "55a8b310-f590-4671-8a78-db5a9de76e3c",
          name: "北京三元桥燕莎店",
          type: "BUILDING",
          parentId: null
        },
        {
          id: "child-id-1",
          name: "一层",
          type: "AREA",
          parentId: "55a8b310-f590-4671-8a78-db5a9de76e3c"
        }
      ],
      message: "层级路径查询成功"
    }, null, 2)
  },
  {
    id: 'space-add-tags',
    method: 'POST',
    path: '/api/spaces/:id/tags',
    name: '添加空间标签',
    description: '为空间添加标签',
    category: API_CATEGORIES.SPACE,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    bodyParams: [
      { name: 'tagIds', type: 'array', required: true, description: '标签ID数组' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:space:update'
  },
  {
    id: 'space-remove-tags',
    method: 'DELETE',
    path: '/api/spaces/:id/tags',
    name: '移除空间标签',
    description: '移除空间的标签',
    category: API_CATEGORIES.SPACE,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '空间ID（UUID）' }
    ],
    bodyParams: [
      { name: 'tagIds', type: 'array', required: true, description: '标签ID数组' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:space:update'
  },
];
